import moment from "moment";
import {EventsTypes} from "@/enums/EventsTypes";
import VueHtml2pdf from 'vue-html2pdf';
import html2canvas from "html2canvas";
import {Calendar} from "@/models/calendar/Calendar";

export default {
  name: 'ResidentCalendar',
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      dialogCalendar: false,
      residentName: '',
      focus: '',
      today: this.formatDate(moment(new Date()).toDate(), true),
      filters: [
        EventsTypes.ConciergeRequest,
        EventsTypes.LifestylePrograms,
        EventsTypes.PremiumServices,
        EventsTypes.Notice
      ],
      title: '',
      type: "week",
      residentId: this.$route.params.id,
      isPdfLoading: false,
      calendarScreenshot: null
    };
  },
  methods: {
    open(open, residentName) {
      this.dialogCalendar = open;
      this.residentName = residentName;
    },
    formatDate(a, withTime): string {
      if(!a) return ''

      return withTime
          ? `${a.getFullYear()}-${a.getMonth() +
          1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
          : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    showEvent({ nativeEvent, event }): void {
      this.$router.push({
        name: 'ViewCalendarEvent',
        params: {
          id: event.id,
        },
      });
    },
    getColor(type, allDay): string {
      if(allDay){
        if (type == EventsTypes.LifestylePrograms) return '#6aa3ff'
        else if (type == EventsTypes.PremiumServices) return '#8cd18e'
        else if (type == EventsTypes.Notice) return '#ff8888'
        else if (type == EventsTypes.FamilyVisit) return '#a869d7'
        else if (type == EventsTypes.Medical) return '#fbc9d2'
        else if (type == EventsTypes.Concierge) return '#ffdb99'
      }
      else{
        if (type == EventsTypes.LifestylePrograms) return '#0D47A1'
        else if (type == EventsTypes.PremiumServices) return '#4caf50'
        else if (type == EventsTypes.Notice) return '#ff0000'
        else if (type == EventsTypes.FamilyVisit) return'#4b0082'
        else if (type == EventsTypes.Medical) return '#ffc0cb'
        else if (type == EventsTypes.Concierge) return '#ffa500'
      }
  
      return '#ffa500'
    },
    prev(): void {
      this.$refs.calendar.prev();
    },
    next(): void {
      this.$refs.calendar.next();
    },
    changeCalendar() {
      this.title = this.$refs.calendar.title;
    },
    intervalFormatter(locale, getOptions) {
      const format = this.facility.timeFormat.split(' ')[1] || ''
      let timeFormatted = moment(locale.time, ["HH:mm"]).format(`${format == 'A' ? 'h' : 'H'}${format ? ' ' + format : ''}`)
      timeFormatted = timeFormatted === '0'?'24':timeFormatted
  
      return timeFormatted;
    },
    generatePdf() {
      this.isPdfLoading = true;

      setTimeout(async () => {

        const canvas = await html2canvas(document.querySelector('#calendar'));

        const url = canvas.toDataURL();

        this.calendarScreenshot = url;
        (this.$refs as any).html2Pdf.generatePdf();

        this.isPdfLoading = false;
      }, 200);
    }
  },
  computed: {
    facility() {
      return this.$store.state.authModule.currentFacilityData;
    },

    calendarEventsUpcoming(): Calendar[] {
      return this.$store.state.calenderModule.currentResidentsCalendarEvents;
    },

    calendarEventsPast(): Calendar[] {
      return this.$store.state.calenderModule.currentResidentCalendarEventsPast;
    },

    events() {
      const events = [...this.calendarEventsPast, ...this.calendarEventsUpcoming]
      const eventsResult = [];

      for (let i = 0; i < events.length; i++) {
        const dbEvt = events[i];
        if(!eventsResult.find(x => x.id === dbEvt.id)) {
          eventsResult.push({
            name: dbEvt.name,
            id: dbEvt.id,
            imageUrl: dbEvt.imageUrl,
            attendees: dbEvt.attendees,
            attendeesIds: dbEvt.attendeesIds ? dbEvt.attendeesIds : [],
            description: dbEvt.description,
            isVirtualEvent: dbEvt.isVirtualEvent,
            going: dbEvt.going,
            notgoing: dbEvt.notgoing,
            goingLen: dbEvt.going?.length,
            notgoingLen: dbEvt.notgoing?.length,
            invitees: dbEvt.invitees,
            attendeesLen: dbEvt.invitees?.length,
            start: this.formatDate(dbEvt.start, true),
            end: this.formatDate(dbEvt.end, true),
            color: this.getColor(dbEvt.type, dbEvt.allDay),
            type: dbEvt.type,
            allDay: dbEvt.allDay
          });
        }
      }

      return eventsResult.filter(event => {
        if (
          event.type === EventsTypes.LifestylePrograms ||
          event.type === EventsTypes.PremiumServices ||
          event.type === EventsTypes.ConciergeRequest ||
          event.type === EventsTypes.Notice
        ) {
          return this.filters.includes(event.type);
        }
        return event;
      });
    }
  }
};
